import configJson from "./auth_config.json";

export function getConfig() {
  // Configure the audience here. By default, it will take whatever is in the config
  // (specified by the `audience` key) unless it's the default value of "{yourApiIdentifier}" (which
  // is what you get sometimes by using the Auth0 sample download tool from the quickstart page, if you
  // don't have an API).
  // If this resolves to `null`, the API page changes to show some helpful info about what to do
  // with the audience.
  const audience =
    configJson.audience && configJson.audience !== "{yourApiIdentifier}"
      ? configJson.audience
      : null;

  return {
    domain: configJson.domain,
    clientId: configJson.clientId,
    ...(configJson.scope ? { scope: configJson.scope } : null),
    ...(audience ? { audience } : null),
    ...(configJson.ui_locales ? { ui_locales: configJson.ui_locales } : null),
    ...(configJson["ext-st"] ? { "ext-st": configJson["ext-st"] } : null),
  };
}
